// i18n — Hindi & English translations
export const translations = {
  en: {
    // Layout
    "nav.dashboard": "Dashboard",
    "nav.numerology": "Numerology",
    "nav.name": "Name Calc",
    "nav.chart": "Birth Chart",
    "nav.matching": "Matching",
    "nav.panchang": "Panchang",
    "nav.palm": "Palm Reading",
    "nav.chat": "Astro Talk",
    "common.logout": "Logout",
    "common.loading": "Loading the cosmos...",
    "common.calculate": "Calculate",
    "common.signin": "Sign in",
    "common.signup": "Get Started",
    "common.signout": "Sign out",
    "common.you": "You",
    "common.reset": "Reset",
    "common.show": "Show",
    "common.hide": "Hide",

    // Palm reading
    "palm.title": "Palm Reading — Vedic Samudrik Shastra",
    "palm.subtitle": "Upload a clear photo of your dominant palm and receive a detailed Samudrik reading covering all lines, mounts, current-year forecast and remedies.",
    "palm.unlimited": "Unlimited readings (subscriber)",
    "palm.free_left": "1 free reading available",
    "palm.credits_left": "credits remaining",
    "palm.locked": "No credits left — unlock a new reading",
    "palm.unlock_title": "Unlock another palm reading",
    "palm.unlock_desc": "Vedic Samudrik reading of every line, mount, current-year forecast, lucky windows and remedies.",
    "palm.pay_india": "One reading (India)",
    "palm.pay_global": "One reading (Global)",
    "palm.upload_title": "Upload palm photo",
    "palm.upload_cta": "Click to upload or drag a palm photo here",
    "palm.upload_hint": "JPG, PNG or WEBP. Bright, close-up shot of the palm with fingers spread.",
    "palm.take_photo": "Take Photo",
    "palm.pick_gallery": "From Gallery",
    "palm.read_btn": "Read My Palm",
    "palm.reading": "Reading your palm...",
    "palm.err_type": "Please upload a JPG, PNG or WEBP image.",
    "palm.err_large": "Image too large — under 6 MB please.",
    "palm.success": "Reading complete — scroll down.",
    "palm.paid_ok": "Payment received — you can read another palm now.",
    "palm.history_title": "Past readings",
    "palm.no_history": "No readings yet — upload your first palm to begin.",
    "palm.history_hint": "See your past palm readings.",
    "palm.tips": "Tips for best results: hold hand under natural daylight, keep fingers spread, camera above the palm, no filters. The dominant (writing) hand shows your active karma.",
    "palm.overall": "Overall Summary",
    "palm.lines": "The Lines",
    "palm.mounts": "The Mounts (Parvat)",
    "palm.year_forecast": "Current Year Forecast (2026)",
    "palm.lucky_periods": "Lucky Periods",
    "palm.remedies": "Vedic Remedies",

    // Landing
    "landing.tagline": "Vedic + Numerology · Powered by AI",
    "landing.heading_pre": "Decode your",
    "landing.heading_em": "cosmic blueprint",
    "landing.subtitle": "Accurate birth charts, numerology calculators, daily panchang & a wise AI astrologer — all in one beautifully crafted experience.",
    "landing.cta_start": "Start Your Reading",
    "landing.cta_existing": "I already have an account",
    "landing.feature.chart.title": "Vedic Birth Chart",
    "landing.feature.chart.desc": "Precise sidereal chart with planets, nakshatras & houses",
    "landing.feature.lucky.title": "Lucky Numbers",
    "landing.feature.lucky.desc": "Discover your lucky numbers, car, house, mobile numbers",
    "landing.feature.name.title": "Name Numerology",
    "landing.feature.name.desc": "Pythagorean & Chaldean name vibration analysis",
    "landing.feature.panchang.title": "Daily Panchang",
    "landing.feature.panchang.desc": "Tithi, Ekadashi, Purnima, Amavasya, Nakshatra & Hora",
    "landing.feature.horoscope.title": "Daily Horoscope",
    "landing.feature.horoscope.desc": "AI-powered horoscope tuned to your zodiac",
    "landing.feature.chat.title": "AI Astro Talk",
    "landing.feature.chat.desc": "Chat with Cosmic Sage — your personal astrologer",

    // Dashboard
    "dash.greeting": "Namaste",
    "dash.intro": "Your cosmic dashboard — daily panchang, hora muhurat, horoscope and quick access to all calculators.",
    "dash.panchang_today": "Today's Panchang",
    "dash.hora_today": "Hora Muhurat",
    "dash.horoscope": "Daily Horoscope",
    "dash.upcoming": "Upcoming Sacred Days",
    "dash.quick_tools": "Quick tools",
    "dash.get": "Get",
    "dash.current_hora": "Current Hora",
    "dash.sunrise": "Sunrise",
    "dash.sunset": "Sunset",
    "dash.day_lord": "Day Lord",
    "dash.pick_sign": "Pick your sign and reveal today's reading",
    "dash.your_rasi": "Your Chandra Rashi",
    "dash.loading_horoscope": "Loading your personalised horoscope...",

    // Numerology
    "num.title": "Lucky Numbers Report",
    "num.subtitle": "Discover your driver, conductor, and lucky combinations based on your birth date.",
    "num.dob": "Date of Birth",
    "num.name": "Full Name (optional)",
    "num.calculate": "Reveal Lucky Numbers",
    "num.calculating": "Calculating...",

    // Birth chart
    "chart.title": "Vedic Birth Chart",
    "chart.subtitle": "Sidereal Lahiri ayanamsa — accurate planetary positions, nakshatras, divisional charts & Vimshottari dasha.",
    "chart.birth_time": "Birth Time",
    "chart.birth_place": "Birth Place",
    "chart.generate": "Generate Birth Chart",
    "chart.computing": "Computing chart...",
    "chart.ascendant": "Ascendant (Lagna)",
    "chart.moon_sign": "Moon Sign (Rashi)",
    "chart.sun_sign": "Sun Sign (Western)",
    "chart.planets": "Planetary Positions",
    "chart.d9": "D9 Navamsa Chart (Marriage & Dharma)",
    "chart.d10": "D10 Dasamsa Chart (Career)",
    "chart.dasha": "Vimshottari Mahadasha",
    "chart.current_period": "Current Period",

    // Chat
    "chat.new": "New Chat",
    "chat.placeholder": "Ask Cosmic Sage anything...",
    "chat.subtitle": "Your AI astrologer",
    "chat.intro": "Ask anything about your astro chart, numerology, remedies or muhurat.",
    "chat.sessions": "Previous Sessions",
    "chat.no_sessions": "No sessions yet",

    // Auth
    "auth.welcome": "Welcome back",
    "auth.signin_sub": "Sign in to continue your cosmic journey",
    "auth.create": "Create your account",
    "auth.create_sub": "Begin your personalized cosmic journey",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full Name",
    "auth.google": "Continue with Google",
    "auth.signing_in": "Signing in...",
    "auth.creating": "Creating account...",
    "auth.new_here": "New here?",
    "auth.have_account": "Already a member?",

    // Tithi tags
    "tag.ekadashi": "Ekadashi (Vrat)",
    "tag.purnima": "Purnima (Full Moon)",
    "tag.amavasya": "Amavasya (New Moon)",
    "tag.chaturdashi": "Chaturdashi",
    "tag.shukla_paksha": "Shukla Paksha",
    "tag.krishna_paksha": "Krishna Paksha",
    "tag.smarta": "Smarta",
    "tag.vaishnava": "Vaishnava",

    // Push / notifications
    "push.on": "Notifications On",
    "push.enable": "Enable Reminders",
    "push.test": "Test",

    // Chat additional
    "chat.extend": "Extend",
    "chat.watch_ad_extend": "Watch Ad",
    "chat.time_left": "left",
    "chat.starter.promotion": "Will I get a promotion this year?",
    "chat.starter.lifepath": "What does my life path number say about my career?",
    "chat.starter.lucky_today": "Suggest a lucky color and number for me today",
    "chat.starter.mangal": "Tell me about Mangal dosha in simple terms",
    "chat.msgs": "msgs",
  },
  hi: {
    // Layout
    "nav.dashboard": "डैशबोर्ड",
    "nav.numerology": "अंक ज्योतिष",
    "nav.name": "नाम गणना",
    "nav.chart": "जन्म कुंडली",
    "nav.matching": "मिलान",
    "nav.panchang": "पंचांग",
    "nav.palm": "हस्तरेखा",
    "nav.chat": "एस्ट्रो टॉक",
    "common.logout": "लॉग आउट",
    "common.loading": "ब्रह्मांड लोड हो रहा है...",
    "common.calculate": "गणना करें",
    "common.signin": "साइन इन",
    "common.signup": "शुरू करें",
    "common.signout": "साइन आउट",
    "common.you": "आप",
    "common.reset": "रीसेट",
    "common.show": "दिखाएँ",
    "common.hide": "छिपाएँ",

    // Palm reading
    "palm.title": "हस्तरेखा शास्त्र — वैदिक सामुद्रिक",
    "palm.subtitle": "अपने प्रमुख हाथ की स्पष्ट फोटो अपलोड करें और प्राप्त करें रेखाओं, पर्वतों, वर्ष 2026 का विस्तृत भविष्यफल तथा उपाय।",
    "palm.unlimited": "असीमित रीडिंग (सब्सक्राइबर)",
    "palm.free_left": "1 निःशुल्क रीडिंग उपलब्ध",
    "palm.credits_left": "रीडिंग शेष",
    "palm.locked": "कोई क्रेडिट नहीं — नई रीडिंग अनलॉक करें",
    "palm.unlock_title": "और हस्तरेखा रीडिंग अनलॉक करें",
    "palm.unlock_desc": "हर रेखा, पर्वत, चालू वर्ष के भविष्यफल, शुभ समय एवं उपाय — पूरी सामुद्रिक विवेचना।",
    "palm.pay_india": "एक रीडिंग (भारत)",
    "palm.pay_global": "एक रीडिंग (ग्लोबल)",
    "palm.upload_title": "हाथ की फोटो अपलोड करें",
    "palm.upload_cta": "यहाँ क्लिक करें या फोटो drag करें",
    "palm.upload_hint": "JPG, PNG या WEBP। उंगलियों को फैलाकर, प्राकृतिक रोशनी में स्पष्ट फोटो।",
    "palm.take_photo": "फोटो लें",
    "palm.pick_gallery": "गैलरी से",
    "palm.read_btn": "मेरी हस्तरेखा पढ़ें",
    "palm.reading": "आपकी हस्तरेखा पढ़ी जा रही है...",
    "palm.err_type": "कृपया JPG, PNG या WEBP छवि अपलोड करें।",
    "palm.err_large": "छवि बहुत बड़ी है — कृपया 6 MB से कम।",
    "palm.success": "रीडिंग पूरी — नीचे स्क्रॉल करें।",
    "palm.paid_ok": "भुगतान प्राप्त — अब आप और रीडिंग कर सकते हैं।",
    "palm.history_title": "पुरानी रीडिंग्स",
    "palm.no_history": "अभी कोई रीडिंग नहीं — पहली अपलोड कीजिए।",
    "palm.history_hint": "अपनी पुरानी हस्तरेखा रीडिंग्स देखें।",
    "palm.tips": "बेहतर परिणाम के लिए: प्राकृतिक रोशनी में हाथ रखें, उंगलियाँ खोलें, कैमरा हथेली के ऊपर, कोई फ़िल्टर नहीं। प्रमुख (लिखने वाला) हाथ आपके सक्रिय कर्म को दर्शाता है।",
    "palm.overall": "समग्र सारांश",
    "palm.lines": "रेखाएँ",
    "palm.mounts": "पर्वत",
    "palm.year_forecast": "चालू वर्ष का भविष्यफल (2026)",
    "palm.lucky_periods": "शुभ समय",
    "palm.remedies": "वैदिक उपाय",

    "landing.tagline": "वैदिक + अंक ज्योतिष · AI द्वारा संचालित",
    "landing.heading_pre": "जानिए अपना",
    "landing.heading_em": "ब्रह्मांडीय खाका",
    "landing.subtitle": "सटीक जन्म कुंडली, अंक ज्योतिष कैलकुलेटर, दैनिक पंचांग और एक बुद्धिमान AI ज्योतिषी — एक सुंदर अनुभव में।",
    "landing.cta_start": "अपनी रीडिंग शुरू करें",
    "landing.cta_existing": "मेरा खाता पहले से है",
    "landing.feature.chart.title": "वैदिक जन्म कुंडली",
    "landing.feature.chart.desc": "ग्रहों, नक्षत्रों और भावों के साथ सटीक सायन कुंडली",
    "landing.feature.lucky.title": "शुभ अंक",
    "landing.feature.lucky.desc": "अपने शुभ अंक, कार, घर, मोबाइल नंबर खोजें",
    "landing.feature.name.title": "नाम अंक ज्योतिष",
    "landing.feature.name.desc": "पाइथागोरस और कैल्डियन नाम विश्लेषण",
    "landing.feature.panchang.title": "दैनिक पंचांग",
    "landing.feature.panchang.desc": "तिथि, एकादशी, पूर्णिमा, अमावस्या, नक्षत्र और होरा",
    "landing.feature.horoscope.title": "दैनिक राशिफल",
    "landing.feature.horoscope.desc": "आपकी राशि के अनुसार AI राशिफल",
    "landing.feature.chat.title": "AI एस्ट्रो टॉक",
    "landing.feature.chat.desc": "कॉस्मिक सेज से बात करें — आपके निजी ज्योतिषी",

    "dash.greeting": "नमस्ते",
    "dash.intro": "आपका ब्रह्मांडीय डैशबोर्ड — दैनिक पंचांग, होरा मुहूर्त, राशिफल और सभी कैलकुलेटर तक त्वरित पहुंच।",
    "dash.panchang_today": "आज का पंचांग",
    "dash.hora_today": "होरा मुहूर्त",
    "dash.horoscope": "दैनिक राशिफल",
    "dash.upcoming": "आगामी पवित्र दिवस",
    "dash.quick_tools": "त्वरित टूल",
    "dash.get": "देखें",
    "dash.current_hora": "वर्तमान होरा",
    "dash.sunrise": "सूर्योदय",
    "dash.sunset": "सूर्यास्त",
    "dash.day_lord": "वार स्वामी",
    "dash.pick_sign": "अपनी राशि चुनें और आज का राशिफल देखें",
    "dash.your_rasi": "आपकी चंद्र राशि",
    "dash.loading_horoscope": "आपका व्यक्तिगत राशिफल लोड हो रहा है...",

    "num.title": "शुभ अंक रिपोर्ट",
    "num.subtitle": "अपने जन्म दिनांक के आधार पर ड्राइवर, कंडक्टर और शुभ संयोजन जानें।",
    "num.dob": "जन्म तिथि",
    "num.name": "पूरा नाम (वैकल्पिक)",
    "num.calculate": "शुभ अंक देखें",
    "num.calculating": "गणना हो रही है...",

    "chart.title": "वैदिक जन्म कुंडली",
    "chart.subtitle": "सायन लाहिरी अयनांश — सटीक ग्रह स्थिति, नक्षत्र, विभागीय कुंडलियां और विंशोत्तरी दशा।",
    "chart.birth_time": "जन्म समय",
    "chart.birth_place": "जन्म स्थान",
    "chart.generate": "कुंडली बनाएं",
    "chart.computing": "कुंडली बन रही है...",
    "chart.ascendant": "लग्न",
    "chart.moon_sign": "चंद्र राशि",
    "chart.sun_sign": "सूर्य राशि (पाश्चात्य)",
    "chart.planets": "ग्रह स्थिति",
    "chart.d9": "D9 नवांश कुंडली (विवाह व धर्म)",
    "chart.d10": "D10 दशमांश कुंडली (करियर)",
    "chart.dasha": "विंशोत्तरी महादशा",
    "chart.current_period": "वर्तमान काल",

    "chat.new": "नया चैट",
    "chat.placeholder": "कॉस्मिक सेज से कुछ भी पूछें...",
    "chat.subtitle": "आपके AI ज्योतिषी",
    "chat.intro": "अपनी कुंडली, अंक ज्योतिष, उपाय या मुहूर्त के बारे में कुछ भी पूछें।",
    "chat.sessions": "पिछले सत्र",
    "chat.no_sessions": "अभी कोई सत्र नहीं",

    "auth.welcome": "वापस स्वागत है",
    "auth.signin_sub": "अपनी ब्रह्मांडीय यात्रा जारी रखने के लिए साइन इन करें",
    "auth.create": "खाता बनाएं",
    "auth.create_sub": "अपनी व्यक्तिगत ब्रह्मांडीय यात्रा शुरू करें",
    "auth.email": "ईमेल",
    "auth.password": "पासवर्ड",
    "auth.name": "पूरा नाम",
    "auth.google": "Google से जारी रखें",
    "auth.signing_in": "साइन इन हो रहा है...",
    "auth.creating": "खाता बन रहा है...",
    "auth.new_here": "नए हैं?",
    "auth.have_account": "पहले से सदस्य हैं?",

    "tag.ekadashi": "एकादशी (व्रत)",
    "tag.purnima": "पूर्णिमा",
    "tag.amavasya": "अमावस्या",
    "tag.chaturdashi": "चतुर्दशी",
    "tag.shukla_paksha": "शुक्ल पक्ष",
    "tag.krishna_paksha": "कृष्ण पक्ष",
    "tag.smarta": "स्मार्त",
    "tag.vaishnava": "वैष्णव",

    "push.on": "सूचनाएँ चालू",
    "push.enable": "रिमाइंडर चालू करें",
    "push.test": "टेस्ट",

    "chat.extend": "बढ़ाएं",
    "chat.watch_ad_extend": "विज्ञापन देखें",
    "chat.time_left": "बाकी",
    "chat.starter.promotion": "क्या इस साल मुझे प्रमोशन मिलेगा?",
    "chat.starter.lifepath": "मेरा लाइफ पाथ नंबर मेरे करियर के बारे में क्या कहता है?",
    "chat.starter.lucky_today": "आज के लिए एक शुभ रंग और अंक बताइए",
    "chat.starter.mangal": "मंगल दोष के बारे में सरल भाषा में बताइए",
    "chat.msgs": "संदेश",
  },
};
